export const ORGANIZATION_ASSIGNMENTS_LIST_QUERY_KEY = 'organization-assignments-list';
export const ASSIGNMENT_QUERY_KEY = 'assignment';
export const ASSIGNMENT_NOTES_QUERY_KEY = 'assignment-notes';
export const ASSIGNMENT_STATUS_HISTORY_QUERY_KEY = 'assignment-status-history';
export const ASSIGNMENT_CHANGE_HISTORY_QUERY_KEY = 'assignment-change-history';
export const ASSIGNMENT_EVENT_HISTORY_QUERY_KEY = 'assignment-event-history';
export const ASSIGNMENT_SHIFT_STATUS_HISTORY_QUERY_KEY = 'assignment-shift-status-history';
export const ASSIGNMENT_SHIFT_CHANGE_HISTORY_QUERY_KEY = 'assignment-shift-change-history';
export const ASSIGNMENT_EXPENSES_QUERY_KEY = 'assignment-expenses';
export const ASSIGNMENT_EXPENSE_CHANGE_HISTORY_QUERY_KEY = 'assignment-expense-change-history';
export const ASSIGNMENT_DOCUMENTS_COUNT_QUERY_KEY = 'assignment-documents-count';
export const ASSIGNMENT_TIMECARDS_QUERY_KEY = 'assignment-timecards';
export const EXPENSE_CATEGORIES_QUERY_KEY = 'expense-categories';
